export default {
	user: {} as any, // save current the logged-in user
	customer: {} as any
};
